export const bindToKeys = (() => {
  const memo = new Map();

  return (handler, keys) => {
    const keyObject = { handler, keys };

    if (!memo.has(keyObject)) {
      memo.set(keyObject, (event) => {
        if (keyObject.keys.includes(event.keyCode)) {
          keyObject.handler(event);
        }
      });
    }

    return memo.get(keyObject);
  };
})();
